import { cn } from '@spiaggeit/spit-ui'

import { MapPreviewCard } from '@/components/MapPreviewCard'
import { useAppSelector } from '@/hooks/store'
import { AccessCard } from '@/routes/ThankYou/AccessCard'
import { isKioskSelector, isWidgetSelector } from '@/store/appSlice'

type Props = React.PropsWithoutRef<{
  className?: string
}>

export const ThankYouCards = (props: Props) => {
  const isKiosk = useAppSelector(isKioskSelector)
  const isWidgetMode = useAppSelector(isWidgetSelector)

  return (
    <div
      className={cn('flex flex-col gap-4 lg:flex-col', props.className, {
        'flex-col-reverse': isWidgetMode,
      })}
    >
      {isWidgetMode ? (
        <MapPreviewCard />
      ) : (
        <>
          {/*<PointsCard />*/}
          {!isKiosk && <AccessCard />}
        </>
      )}
    </div>
  )
}
